import './LottieFileGenarationComponent.scss'
import React from 'react';
import {LottieOptions, useLottie} from "lottie-react";

interface LottieFileGenarationComponentProps {
    animationData?: any
    autoplay?: boolean
    loop?: boolean
    height?: string;
    width?: string;
}

const LottieFileGenarationComponent = (props: LottieFileGenarationComponentProps) => {
    const {animationData, autoplay, loop, height = '300px', width = '300px'} = props

    const options: LottieOptions = {
        animationData: animationData,
        autoplay: autoplay,
        loop: loop,
        style: {
            width: width,
            height: height,
        }
    };
    const {View} = useLottie(options);
    return (
        <div>
            {View}
        </div>
    )
};

export default LottieFileGenarationComponent;
